<div class="tab-form-container">
    <div class="form-field date-field active-date">
        <mat-label>{{'routeForm.dateSelector.date' | transloco}}</mat-label>
        <mat-form-field appearance="outline">
            <input aria-label="Date" [disabled]="disabled" readonly (click)="datePicker.open()" #arriveAtDateInput  [min]="currentDate" matInput [ngModel]="dateField()" (ngModelChange)="dateFieldChanged($event, hourField())"  [matDatepicker]="datePicker">
            <mat-datepicker-toggle [ngClass]="disabled? 'icon-disabled' : ''" [disabled]="disabled" matSuffix [for]="datePicker"></mat-datepicker-toggle>
            <mat-datepicker #datePicker disabled="false"></mat-datepicker>
        </mat-form-field>
    </div>
    <div class="form-field hour-field">
        <mat-label>{{'routeForm.dateSelector.hour' | transloco}}</mat-label>
        <mat-form-field appearance="outline">
            <input aria-label="Hour" [disabled]="disabled" matInput [ngModel]="hourField()" [min]="minHour()" (ngModelChange)="dateFieldChanged(dateField(), $event)" [format]="24" [ngxMatTimepicker]="arriveAt" readonly>
            <mat-icon [ngClass]="disabled? 'icon-disabled' : ''" class="clockTimePicker" matSuffix (click)=" disabled ? '' : arriveAt.open()">schedule</mat-icon>
            <ngx-mat-timepicker [cancelBtnTmpl]="CancelButton" [confirmBtnTmpl]="AcceptButton" #arriveAt></ngx-mat-timepicker>
        </mat-form-field>
    </div>
</div>

<ng-template #AcceptButton>
    <button color="primary" class="actionDatePickerButton" mat-button>{{'routeForm.dateSelector.accept' | transloco}}</button>
</ng-template>

<ng-template #CancelButton>
    <button color="primary" class="actionDatePickerButton" mat-button>{{'routeForm.dateSelector.cancel' | transloco}}</button>
</ng-template>